import { makeStyles } from "@material-ui/styles"
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles((theme) => ({
  valueCell: {
    width: "var(--width)",
    minWidth: "var(--width)",
  },
  // ["cell-xxs"]: {
  //   "--width": `${CELL_WIDTHS.VALUE.XXSMALL}px`,
  // },
  // ["cell-xs"]: {
  //   "--width": `${CELL_WIDTHS.VALUE.XSMALL}px`,
  // },
  ["cell-small"]: {
    "--width": `${CELL_WIDTHS.VALUE.SMALL}px`,
  },
  ["cell-medium"]: {
    "--width": `${CELL_WIDTHS.VALUE.MEDIUM}px`,
  },
  ["cell-large"]: {
    "--width": `${CELL_WIDTHS.VALUE.LARGE}px`,
  },
  ["cell-xLarge"]: {
    "--width": `${CELL_WIDTHS.VALUE.XLARGE}px`,
  },
  ["cell-2xLarge"]: {
    "--width": `${CELL_WIDTHS.VALUE.XXLARGE}px`,
  },
  isSticky: {
    zIndex: 4,
    position: "sticky",
    right: ({ colName }) => `var(--right-${colName})`,
  },
  dynamicWidth: {
    zIndex: ({ colName }) => `var(--index-${colName})`,
    width: ({ colName, extendPadding }) => extendPadding ? `calc(var(--maxWidth-${colName}) + 16px)` : `var(--maxWidth-${colName})`,
    minWidth: ({ colName, extendPadding }) => extendPadding ? `calc(var(--minWidth-${colName}) + 16px)` : `var(--minWidth-${colName})`,
  },
  priceContainerBackground: {
    borderRadius: 3,
    backgroundColor: theme.palette.primary.main + "0d",
  },
  extendPadding: {
    paddingRight: "16px !important",
    width: "calc(var(--width) + 16px)",
    minWidth: "calc(var(--width) + 16px)",
  },
  inputContainerBackground: {
    borderRadius: 3,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.primary.main + "0d",
  },
  halfInputWidth: {
    width: "calc(100% - 8px)"
  }
}));

export default useStyle;
